export * from './PaperclipSmallIcon'
